<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="evaluate student-co-evaluation" v-else>
      <b-container fluid>
        <br />
        <b-row>
          <b-col cols="6">
            <h3>Students Vs Course outcomes Score Table</h3>
          </b-col>
          <!-- <b-col cols="6" class="text-right">
            <span v-if="exam_id == null" @click="closeCurrentTab()" class="btn m-0">
              <i class="fas fa-window-close fa-4x text-danger"></i>
            </span>
            <span v-else @click="$root.clearSubContent" class="btn m-0">
              <i class="fas fa-window-close fa-4x text-danger"></i>
            </span>
          </b-col> -->
        </b-row>
        <!-- toggle other sections teaching the same course code in/out of this activity -->
        <b-row :class="'m-2 mb-2 pb-2 border-bottom border-info'" v-if="sectionCheckboxOptions.length > 0">
          <b-col cols="3">Sections in this activity:</b-col>
          <b-col>
            <b-form-checkbox-group
              v-model="selectedSectionIds"
              :options="sectionCheckboxOptions"
              :disabled="sectionActionInProgress"
              @change="onSectionSelectionChange"
              stacked
              name="activity-sections">
            </b-form-checkbox-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th rowspan="3" v-if="studentListOrder !== 'roll_number'">
                    {{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : 'Register No.' }}
                  </th>
                  <th rowspan="3">Participant</th>
                  <th :colspan="courseoutcomes.length">Course outcomes</th>
                  <th rowspan="3">Total</th>
                  <th rowspan="3">%</th>
                </tr>
                <tr>
                  <th v-for="(co, coIndex) in courseoutcomes" :key="coIndex">
                    {{ co.code }}
                  </th>
                </tr>
                <tr>
                  <th v-for="(co, coIndex) in courseoutcomes" :key="coIndex">
                    <input type="number" min="0" v-model="coMaxScores[co.id]" placeholder="max. score" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in tableRows" :key="rowIndex">
                  <template v-if="row.type === 'divider'">
                    <td :colspan="courseoutcomes.length + 4" class="bg-secondary text-white font-weight-bold text-left pl-2">
                      {{ row.section_label }}
                    </td>
                  </template>
                  <template v-else-if="scoreDataobject[row.student.id]">
                    <td v-if="studentListOrder !== 'roll_number'">
                      {{ studentListOrder === 'enrollment_no' ? row.student.enrollment_no : studentListOrder === 'admission_number' ? row.student.admission_no : row.student.register_no }}
                    </td>
                    <td>
                      {{ row.student.first_name || " " }}
                      {{ row.student.last_name || " " }}
                    </td>
                    <td v-for="(co, coIndex) in courseoutcomes" :key="coIndex">
                      <input type="number" min="0" v-model="scoreDataobject[row.student.id][co.id]"
                        :class="{ 'invalid-input': Number(scoreDataobject[row.student.id][co.id]) > Number(coMaxScores[co.id]) }"
                        placeholder="score" />
                    </td>
                    <td>{{ studentsTotelScore[row.student.id] }}/{{ coMaxScoreSum }}</td>
                    <td><span v-if="(coMaxScoreSum > 0)"> {{ Math.round((studentsTotelScore[row.student.id] * 10000) /
                        coMaxScoreSum) / 100
                    }}</span></td>
                  </template>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button type="submit" variant="primary" :disabled="savebutton.disabled" @click="saveScores()">{{
                savebutton.text
            }}</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ['exam_id'],
  async created() {
    this.fetchData = true;
    // console.log();
    await this.getExam();
    // if (!this.exam.co_score_evaluation) {
    //   window.alert(
    //     'This option not avilable for Activity with "Evaluation by CO score" disabled'
    //   );
    //   return;
    // }
    await this.fetchLinkedSections();
    this.selectedSectionIds = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
    await this.getCourseoutcomes();
    await this.getExamParticipants();
    await this.prepareParticipantScoreData(); // initiate and set values 
    if (this.exam.max_co_scores != null) {
      for (const coId in this.exam.max_co_scores) {
        if (coId in this.coMaxScores) {
          this.coMaxScores[coId] = this.exam.max_co_scores[coId];
        }
      }
    }
    this.fetchData = false;
    // this.getCourseoutcomes();
  },
  data() {
    return {
      fetchData: false,
      scoreDataobject: {}, // {student id: co id: score,}
      studentsTotelScoreObject: {},
      coMaxScores: {},
      exam: {},
      students: [],
      studentListOrder: 'roll_number',
      courseoutcomes: [],
      savebutton: {
        text: "Save",
        disabled: false,
      },

      linkedSections: [], // sibling course sections (same code, same faculty, same semester) not yet attached to this activity
      selectedSectionIds: [], // course_ids currently checked (attached, excluding the primary course)
      sectionActionInProgress: false,
    };
  },
  computed: {
    // the course this activity was originally created for; not itself toggleable
    primaryCourseId() {
      return (this.exam.course || [])[0] ? this.exam.course[0].id : null;
    },
    // true once this activity has been attached to more than one section
    hasMultipleSections() {
      return (this.exam.course || []).length > 1;
    },
    // checkbox options: sections already attached (besides the primary) + sections
    // available to add, so checking/unchecking either attaches or detaches
    sectionCheckboxOptions() {
      const attached = (this.exam.course || [])
        .filter(course => course.id !== this.primaryCourseId)
        .map(course => ({ value: course.id, text: course.usersubgroup.name }));
      const notAttached = this.linkedSections.map(section => ({ value: section.course_id, text: section.section_label }));
      return [...attached, ...notAttached];
    },
    // flattens the student list into table rows, inserting a section divider
    // row before the first student of each new section group
    tableRows() {
      const rows = [];
      this.students.forEach((student, index) => {
        if (this.hasMultipleSections && this.isNewSectionGroup(index)) {
          rows.push({ type: 'divider', section_label: student.section_label });
        }
        rows.push({ type: 'student', student });
      });
      return rows;
    },
    studentsTotelScore() {
      let studentsTotelScoreObject = {};
      for (const studId in this.scoreDataobject) {
        studentsTotelScoreObject[studId] = 0;
        for (const coId in this.scoreDataobject[studId]) {
          studentsTotelScoreObject[studId] += Number(this.scoreDataobject[studId][coId]) || 0;
        }
      }
      return studentsTotelScoreObject;
    },
    coMaxScoreSum() {
      let scoreSum = 0;
      for (const key in this.coMaxScores) {
        scoreSum += Number(this.coMaxScores[key]) || 0;
      }
      return scoreSum;
    },
  },
  methods: {
    // async assignMarks() {
    //   this.marksBtn.text = "Please Wait...";
    //   this.marksBtn.disabled = true;
    //   const studentScore = {
    //     exam_scores: [],
    //   };
    //   await this.studentSheet.forEach((student) => {
    //     if (student.studentId != "") {
    //       studentScore.exam_scores.push({
    //         examquestion_id: student.questionId,
    //         student_id: student.studentId,
    //         score: student.marks,
    //       });
    //     }
    //   });
    //   const url = this.$store.getters.getAPIKey.examAnswers + `/marks`;

    //   axios
    //     .post(url, studentScore)
    //     .then((response) => {
    //       this.clearResponse(this.studentSheet[0].studentId);
    //       response;
    //     })
    //     .catch((error) => {
    //       //   this.clearResponse();
    //       error;
    //     });
    // },
    async getExam() {
      var examId = this.$route.params.exam_id;
      if (!examId) examId = this.exam_id;
      const url = this.$store.getters.getAPIKey.examination + `/${examId}`;

      await axios
        .get(url)
        .then((response) => {
          this.exam = {};
          this.exam = response.data;
          // this.getCourse();
          // response;
        })
        .catch((error) => {
          if (error.response) {
            this.$toast.error(`${error.response.data.message}`, {
              position: "top-right",
              duration: 4000,
            });
          }
        });
    },
    async getExamParticipants() {
      const participantsUrl =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.exam.id}/examparticipants`;
      await this.$axios
        .get(participantsUrl)
        .then((response) => {
          this.studentListOrder = response.data.student_order || 'roll_number';
        })
        .catch((error) => {
          if (error.response) {
            this.$toast.error(`${error.response.data.message}`, {
              position: "top-right",
              duration: 4000,
            });
          }
        });

      // the roster of every course attached to this activity is the source of truth for
      // who should be listed, regardless of whether a participant row exists yet
      let students = [];
      for (const course of this.exam.course) {
        const courseUrl = `${this.$store.getters.getAPIKey.mainAPI}/courseusersindex?role=2&course=${course.id}`;
        let courseStudents = [];
        await this.$axios.get(courseUrl).then((response) => {
          const data = response.data;
          courseStudents = Array.isArray(data) ? data : (data.users ?? []);
        });
        courseStudents.forEach(courseStudent => {
          students.push({
            id: courseStudent.institution_user_id,
            first_name: courseStudent.first_name,
            last_name: courseStudent.last_name,
            roll_number: courseStudent.roll_number,
            admission_no: courseStudent.admission_no,
            enrollment_no: courseStudent.enrollment_no,
            register_no: courseStudent.register_no,
            section_label: course.usersubgroup.name,
          });
        });
      }

      // group by section so combined classes aren't interleaved, keeping each
      // section's own relative order (e.g. roll number) intact
      const order = [];
      const groups = {};
      students.forEach(student => {
        const key = student.section_label || '';
        if (!groups[key]) { groups[key] = []; order.push(key); }
        groups[key].push(student);
      });
      this.students = order.flatMap(key => groups[key]);
    },

    isNewSectionGroup(studentIndex) {
      if (studentIndex === 0) return true;
      return this.students[studentIndex].section_label !== this.students[studentIndex - 1].section_label;
    },

    async fetchLinkedSections() {
      this.linkedSections = [];
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.exam.id}/linkedsections`;
      await this.$axios.get(url).then((response) => {
        this.linkedSections = response.data;
      }).catch((error) => {
        error;
      });
    },

    async attachLinkedSection(courseId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.exam.id}/attachcoursesection`;
      let success = false;
      await this.$axios.post(url, { course_id: courseId })
        .then(() => { success = true; })
        .catch((error) => {
          error;
          this.$toast.error('Failed to add section, please try again', { position: "top-right", duration: 5000 });
        });
      return success;
    },

    async detachLinkedSection(courseId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.exam.id}/detachcoursesection`;
      let success = false;
      await this.$axios.post(url, { course_id: courseId })
        .then(() => { success = true; })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to remove section, please try again';
          this.$toast.error(message, { position: "top-right", duration: 7000 });
        });
      return success;
    },

    // v-model of the checkbox group has already flipped to the newly-checked state;
    // diff it against what's actually attached to figure out what to attach/detach
    async onSectionSelectionChange(newSelection) {
      this.sectionActionInProgress = true;
      // hide the table while students/scoreDataobject are updated in separate steps below,
      // otherwise Vue can render students with no scoreDataobject entry yet and crash
      this.fetchData = true;
      const currentlyAttached = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
      const toAttach = newSelection.filter(courseId => !currentlyAttached.includes(courseId));
      const toDetach = currentlyAttached.filter(courseId => !newSelection.includes(courseId));

      for (const courseId of toAttach) {
        await this.attachLinkedSection(courseId);
      }
      for (const courseId of toDetach) {
        await this.detachLinkedSection(courseId);
      }

      await this.getExam(); // refreshes exam.course to reflect what actually attached/detached
      await this.fetchLinkedSections();
      await this.getExamParticipants();
      await this.prepareParticipantScoreData();
      // reconcile checkboxes with reality - a blocked detach snaps back to checked
      this.selectedSectionIds = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
      this.sectionActionInProgress = false;
      this.fetchData = false;
    },
    async prepareParticipantScoreData() {
      await this.sortedArray();

      await this.students.forEach((student) => {
        this.$set(this.scoreDataobject, student.id, {})
        // this.scoreDataobject[student.id] = {};
        this.courseoutcomes.forEach((co) => {
          this.$set(this.scoreDataobject[student.id], co.id, null)
          // this.scoreDataobject[student.id][co.id] = null;
        });
      });

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.exam.id}/examparticipants/courseoutcomes/score`;
      let participantsdata = [];
      await axios
        .get(url)
        .then((response) => {
          participantsdata = response.data;
        })
        .catch((error) => {
          if (error.response) {
            this.$toast.error(`${error.response.data.message}`, {
              position: "top-right",
              duration: 4000,
            });
          }
        });
      await participantsdata.forEach((student) => {
        if (student.institution_user_id in this.scoreDataobject) {
          let studentcoscore = student.courseoutcomes_score;
          if (studentcoscore) {
            for (var cokey in studentcoscore) {
              if (cokey in this.scoreDataobject[student.institution_user_id])
                this.scoreDataobject[student.institution_user_id][cokey] =
                  studentcoscore[cokey];
            }
          }
        }
      });
    },
    async getCourseoutcomes() {
      this.fetchData = true;
      let courseOutcomeUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
      // console.log(this.exam);
      const url = courseOutcomeUrl.replace("course_id", this.exam.course[0].id);
      await axios
        .get(url)
        .then((response) => {
          this.courseoutcomes = response.data;
        })
        .catch((error) => {
          if (error.response) {
            this.$toast.error(`${error.response.data.message}`, {
              position: "top-right",
              duration: 4000,
            });
          }
        });

      await this.courseoutcomes.forEach((co) => {
        // this.coMaxScores[co.id] = null;
        this.$set(this.coMaxScores, co.id, null)
      });
    },

    async saveScores() {
      this.savebutton = {
        text: "Saving...",
        disabled: true,
      };
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/examparticipants/courseoutcomes/score`;
      var postData = {};
      postData["exam"] = this.exam.id;
      postData["participants_cos_score"] = this.scoreDataobject;
      postData["max_co_scores"] = this.coMaxScores;
      await this.$axios
        .post(url, postData)
        .then(() => {
          this.$toast.success(`Scores saved successfully`, {
            position: "top-right",
            duration: 3000,
          });
          this.$emit("GroupCreated", true);
        })
        .catch((error) => {
          this.savebutton = {
            text: "Save",
            disabled: false,
          };
          if (error.response) {
            this.$toast.error(
              `Failed to save : ${error.response.data.message}`,
              {
                position: "top-right",
                duration: 4000,
              }
            );
          }
        });
      this.savebutton = {
        text: "Save",
        disabled: false,
      };

      // console.log(postData);
    },

    async sortedArray() {
      this.fetchData = true;
      // await this.students.sort(function(a, b) {
      //   return (
      //     a.roll_number - b.roll_number ||
      //     a.first_name.localeCompare(b.first_name)
      //   );
      // });
      // this.fetchData = false;
      return true;
    },
  },
};
</script>

<style >
.student-co-evaluation table td {
  position: relative;
}

.invalid-input {
  border: 1px solid red !important;
}

.student-co-evaluation table td input {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 10px;
  box-sizing: border-box;
}

</style>
